module.exports = __webpack_public_path__ + "img/RX-Arcos-1.12dca4dc.png";